export default class ResponseHandler {
    getData(response) {
        return response.data || [];
    }

    getErrors(response) {
        return response.errors || [];
    }

    getForm(response) {
        return response.form || '';
    }

    getFormAddress(response) {
        return response.form_address || '';
    }

    getFormDuration(response) {
        return response.form_duration || '';
    }

    isSuccess(response) {
        return this.checkResult(response, 'SUCCESS');
    }

    getResult(response) {
        return response.result || '';
    }

    checkResult(response, value = 'ERROR') {
        let result = this.getResult(response);

        if (!result) {
            console.error(response, 'Result is not set on the response object, assuming an error.');
            result = 'ERROR';
        }

        return result === value;
    }
}
